export const AppConfig = Object.freeze({
  ENV: {
    API_URL: import.meta.env.VITE_API_URL,
    MEMBERSHIP_API_URL: import.meta.env.VITE_MEMBERSHIP_API_URL,
    APP_URL: import.meta.env.VITE_APP_URL,
    DOKOKOKO_API_URL: import.meta.env.VITE_DOKOKOKO_API_URL,
    ENVIRONMENT: import.meta.env.VITE_ENV,
    STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  },
  TIMERS: {
    DEBOUNCE_SEARCH: 300,
    COMPONENT_LOAD: 500,
    STANDARD_DELAY: 1000,
    SNACKBAR_SUCCESS: 3000,
    SNACKBAR_ERROR: 5000,
  },
});
